import api from './auth';

// GET /api/mqtt/servers - 获取所有MQTT服务器
export const getMqttServers = () =>
  api.get('/mqtt/servers');

// POST /api/mqtt/servers - 创建新的MQTT服务器
export const createMqttServer = (data: {
  name: string;
  url: string;
  port: number;
  useTls?: boolean;
  username?: string;
  password?: string;
  enabled?: boolean;
  isDefault?: boolean;
  description?: string;
}) =>
  api.post('/mqtt/servers', data);

// PUT /api/mqtt/servers/:id - 更新MQTT服务器
export const updateMqttServer = (id: number, data: {
  name?: string;
  url?: string;
  port?: number;
  useTls?: boolean;
  username?: string;
  password?: string;
  enabled?: boolean;
  isDefault?: boolean;
  description?: string;
}) =>
  api.put(`/mqtt/servers/${id}`, data);

// DELETE /api/mqtt/servers/:id - 删除MQTT服务器
export const deleteMqttServer = (id: number) =>
  api.delete(`/mqtt/servers/${id}`);

// GET /api/mqtt/subscriptions - 获取所有MQTT订阅配置
export const getMqttSubscriptions = () =>
  api.get('/mqtt/subscriptions');

// GET /api/mqtt/subscriptions/server/:serverId - 获取指定服务器的订阅配置
export const getSubscriptionsByServer = (serverId: number) =>
  api.get(`/mqtt/subscriptions/server/${serverId}`);

// GET /api/mqtt/subscriptions/channels/distinct - 获取所有唯一的频道名称
export const getDistinctChannels = (serverId?: number) => {
  const url = serverId 
    ? `/mqtt/subscriptions/channels/distinct?serverId=${serverId}`
    : '/mqtt/subscriptions/channels/distinct';
  return api.get(url);
};

// GET /api/mqtt/subscriptions/:id - 获取单个订阅配置
export const getSubscriptionById = (id: number) =>
  api.get(`/mqtt/subscriptions/${id}`);

// POST /api/mqtt/subscriptions - 创建新的订阅配置
export const createSubscription = (data: {
  serverId: number;
  channelName: string;
  topicPattern: string;
  qos?: number;
  enabled?: boolean;
  description?: string;
}) =>
  api.post('/mqtt/subscriptions', data);

// PUT /api/mqtt/subscriptions/:id - 更新订阅配置
export const updateSubscription = (id: number, data: {
  channelName?: string;
  topicPattern?: string;
  qos?: number;
  enabled?: boolean;
  description?: string;
}) =>
  api.put(`/mqtt/subscriptions/${id}`, data);

// DELETE /api/mqtt/subscriptions/:id - 删除订阅配置
export const deleteSubscription = (id: number) =>
  api.delete(`/mqtt/subscriptions/${id}`);

// POST /api/mqtt/subscriptions/refresh/:serverId - 刷新服务器订阅
export const refreshSubscriptions = (serverId: number) =>
  api.post(`/mqtt/subscriptions/refresh/${serverId}`);

export interface MqttChannel {
  id: number;
  serverId: number;
  channelName: string;
  enabled: boolean;
}
export interface ChannelResult extends MqttChannel {
  refresh: Array<{ success: boolean; message: string }>;
}
export const getMqttChannels = () => api.get<MqttChannel[]>('/mqtt/subscriptions/channels');
export const createMqttChannel = (data: Omit<MqttChannel, 'id' | 'enabled'> & { enabled?: boolean }) =>
  api.post<ChannelResult>('/mqtt/subscriptions/channels', data);
export const updateMqttChannel = (id: number, data: Omit<MqttChannel, 'id'>) =>
  api.put<ChannelResult>(`/mqtt/subscriptions/channels/${id}`, data);
export const deleteMqttChannel = (id: number) =>
  api.delete<{ refresh: ChannelResult['refresh'] }>(`/mqtt/subscriptions/channels/${id}`);
